import { gql } from "@apollo/client";
export const APP_FILE_UPLOAD = gql `
  mutation AppFileUpload($upload: Upload!) {
    AppFileUpload(upload: $upload) {
      _id
      downloadUrl
    }
  }
`;
